import { api } from '../config'
import { AxiosResponse } from 'axios'

export type EventSummaryResponse = {
  id: string
  name: string
  description?: string
  isPublic: boolean
  createdAt: string
  updatedAt?: string
  creatorId?: string
  summary: {
    confirmedPayments: number
    pendingPayments: number
    creditSales: number
    pixSales: number
  }
  customerStatics: {
    total: number
    totalAttendence: number
    totalPayers: number
    views: number
    viewsWithoutPayment: number
  }
}

export const eventSummaryService = async (eventId: string) => {
  const { data }: AxiosResponse<EventSummaryResponse> = await api.get(
    `/api/creators/events/${eventId}/summary`
  )

  data.summary.confirmedPayments /= 100
  data.summary.creditSales /= 100
  data.summary.pixSales /= 100
  data.summary.pendingPayments /= 100

  return data
}
